const colors = {
  background: {
    primary: '#f3f4f72e',
    secondary: '#F1F6FC'
  },
  blue: {
    primary: '#01205C',
    secondary: '#2A60BC',
    tertiary: '#ECF0F7',
    quaternary: '#001C3C',
    quinary: '#F1F6FC',
    senary: '#F2F7FD'
  },
  orange: {
    primary: '#EC6A49',
    secondary: '#FFE9E3'
  },
  gray: {
    primary: '#DEE5EC',
    secondary: '#6a7888ab',
    tertiary: '#2A3C50'
  },
  green: {
    primary: '#3BB213',
    secondary: '#E2F4DC'
  },
  white: {
    primary: '#ffffff'
  },
  black: {
    primary: '#000000',
    secondary: '#323232',
    tertiary: ' #b6b6b6d1'
  },
  red: {
    primary: '#ff0000'
  },
  switch: {
    primary: '#0071f2'
  }
};
export default colors;
